export const PAGELOAD_KEY = 'pageload';

export const ActionTypes = {
    SET_PAGE_TRACE_ID: 'actions/pageload/set_page_id',
    SET_BOT_INFO: 'actions/pageload/set_bot_info',
};
